import React from "react";
import { Check } from "lucide-react";
import { businessInfo } from "../data/mock";
import "../styles/About.css";

const About = () => {
  return (
    <section id="about" className="about-section section-padding">
      <div className="container">
        {/* Why Choose Section */}
        <div className="why-choose-section">
          <h2 className="hero-medium text-center">Why Choose<br />Aura Aesthetics Academy</h2>
          
          <div className="why-choose-grid">
            <div className="why-choose-item">
              <div className="check-icon">
                <Check size={32} strokeWidth={3} />
              </div>
              <p className="body-large">Nurse-led clinic with extensive patient-care experience</p>
            </div>
            <div className="why-choose-item">
              <div className="check-icon">
                <Check size={32} strokeWidth={3} />
              </div>
              <p className="body-large">Medical-grade products & techniques</p>
            </div>
            <div className="why-choose-item">
              <div className="check-icon">
                <Check size={32} strokeWidth={3} />
              </div>
              <p className="body-large">Personalised consultations for every client</p>
            </div>
            <div className="why-choose-item">
              <div className="check-icon">
                <Check size={32} strokeWidth={3} />
              </div>
              <p className="body-large">Natural, refined results — never overdone</p>
            </div>
            <div className="why-choose-item">
              <div className="check-icon">
                <Check size={32} strokeWidth={3} />
              </div>
              <p className="body-large">Calm, private, professional environment</p>
            </div>
          </div>

          <div className="why-choose-footer">
            <p className="body-large">
              Whether you're booking a facial, injectable, vitamin drip or body treatment, 
              your safety, comfort and results always come first.
            </p>
          </div>
        </div>

        <div className="divider"></div>

        {/* Nurse-Led Treatments Section */}
        <div className="treatments-section">
          <h2 className="hero-medium text-center">Nurse-Led<br />Aesthetic & Wellness<br />Treatments</h2>
          
          <p className="body-large text-center treatments-intro">
            At Aura Aesthetics Academy, every treatment is delivered with precision, care and clinical expertise.
          </p>

          <div className="specialise-section">
            <h3 className="heading-2 text-center">We specialise in:</h3>
            <ul className="specialise-list">
              <li className="body-large">Advanced facials & skin treatments</li>
              <li className="body-large">Skin rejuvenation & regenerative therapies</li>
              <li className="body-large">Medical-grade injectables</li>
              <li className="body-large">Vitamin & wellness therapy</li>
            </ul>
          </div>

          <p className="body-large text-center treatments-footer">
            All treatments are tailored, evidence-based, and designed to enhance your natural beauty — <em>safely and subtly</em>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
